"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _withIcon = _interopRequireDefault(require("./withIcon"));
const NavigationClosePrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M24.3 25.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4L17.4 16l8.3-8.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L16 14.6 7.7 6.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l8.3 8.3-8.3 8.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l8.3-8.3 8.3 8.3z",
  clipRule: "evenodd"
}));
const NavigationCloseMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 22 22"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M18.7071068,4 L19.4142136,4.70710678 L12.414,11.707 L19.4142136,18.7071068 L18.7071068,19.4142136 L11.707,12.414 L4.70710678,19.4142136 L4,18.7071068 L11,11.707 L4,4.70710678 L4.70710678,4 L11.707,11 L18.7071068,4 Z"
}));
const AbstractNavigationClose = ({
  theme,
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(NavigationCloseMDS, other) : _react.default.createElement(NavigationClosePrizm, other);
var _default = exports.default = (0, _styledComponents.withTheme)((0, _withIcon.default)('NavigationClose')(AbstractNavigationClose));